<mat-card>
  <mat-card-title>
    {{ '+INSTALLATIONS.INSTALLATION.OWNER_CARD.BUILDING_CARD_DETAILS' | translate }}
  </mat-card-title>
  <mat-card-content>
    <div class="flex flex-col">
      <form [formGroup]="buildingInfo">
        <div class="flex flex-row">
          <mat-form-field
            mat-input-height-large-label
            class="flex flex-row gap-[16px] flex-[100%] max-w-[100%]"
            id="name"
          >
            <mat-label>{{
              '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.BUILDING_NAME' | translate
            }}</mat-label>
            <input
              matInput
              formControlName="buildingName"
              maxlength="512"
              data-at-name-edit
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="email">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.EMAIL' | translate }}</mat-label>
            <input
              matInput
              formControlName="buildingEmail"
              maxlength="300"
              email="true"
              data-at-email-edit
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="phone">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.TELEPHONE' | translate }}</mat-label>
            <input
              matInput
              formControlName="buildingPhone"
              maxlength="32"
              data-at-phone-edit
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
      </form>
      <form [formGroup]="addressInfo">
        <div class="flex flex-row">
          <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="street">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.STREET' | translate }}</mat-label>
            <input
              matInput
              formControlName="street"
              maxlength="128"
              [errorStateMatcher]="matcher"
              data-at-street-edit
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field
            mat-input-height-large-label
            class="flex-[100%] max-w-[100%]"
            id="houseNumber"
          >
            <mat-label>{{
              '+USER_DETAILS.PERSONAL_DETAILS.BUILDING_NUMBER' | translate
            }}</mat-label>
            <input
              matInput
              formControlName="houseNumber"
              maxlength="32"
              data-at-house-number-edit
              [errorStateMatcher]="matcher"
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="zip">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.ZIP' | translate }}</mat-label>
            <input
              matInput
              formControlName="zip"
              maxlength="64"
              data-at-zip-edit
              [errorStateMatcher]="matcher"
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="city">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.CITY' | translate }}</mat-label>
            <input
              matInput
              formControlName="city"
              maxlength="128"
              data-at-city-edit
              [errorStateMatcher]="matcher"
              fieldTextContentTooltip
            />
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-card-content>
  <mat-card-actions align="end" class="flex flex-row gap-[8px] justify-end items-center">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userPersonalDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="buildingInfo.invalid || addressInfo.invalid"
      gtm="onSave"
      gtmCategory="userPersonalDetails"
      (click)="onSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
